export default {
    dashboard: `首页`,
    people: '账号',
    administrators: `管理员`,
    customers: `客户`,
    suppliers: `供应商`,
    retailers: `零售`,
    drivers: `派送员`,
    workers: `仓库员`,
    members: '会员',
    products: '商品',
    items: '物品',
    productItems: '商品物品详细',
    categories: '分类',
    brands: '品牌',
    uoms: '计量单位',
    documents: '文件',
    sales: '销售',
    salesOrders: '销售订单',
    perfomaSales: '形式销售',
    // 'Sales Invoices': '销售发票',
    salesInvoices: '销售发票',
    // 'Delivery Orders': '送货单',
    deliveryOrders: '送货单',

    cashSales: '现金销售',
    salesDebitNotes: '销售借记单',
    salesCreditNotes: '销售贷记单',
    replacementDeliveries: '替换交货',
    retailCashSales: '零售收银',
    retailPrescription: '零售处方',
    purchases: '采购',
    purchaseOrders: '采购订单',
    purchaseReturns: '采购退货',
    purchaseInvoices: '采购发票',

    parcel: '包裹',
    warehouse: '仓库',
    // 'Item Receives': '签收货物',
    itemReceives: '签收货物',
    itemTransfers: '物品转移',
    itemRelocates: '物品迁移',
    itemTransforms: '物品转换',
    itemIssues: '物品问题',
    itemAdjustments: '物品调整',
    stockTakes: '核对库存',
    transferReturns: '调拨退货',
    transferRequisitions: '调拨申请',
    pickOrders: '拣货单',
    others: '其他',
    operations: '运营',
    itemRelocateThreshold: '物品迁移阈值',
    itemReorderThreshold: '物品复购阈值',
    examineInventory: '检查库存',
    reports: '报表',
    delivery: '交货订单',
    inventories: '库存',

    logistics: '物流',
    transporters: '运输公司',
    deliveryTrips: '送货行程',
    repositories: '存储库',
    containers: '货柜',
    packages: '包裹',
    packPackages: '包装包裹',
    queryPackages: '查询包裹',
    groups: '群组',
    administratorGroups: '管理员群',
    customerGroups: '客户群',
    supplierGroups: '供应商群',
    settings: '设定',
    rolesAndPermissions: '身份与权限',
    business: '企业',
    locations: '仓库',
    regions: '区域',
    countryAndRegions: '城市与区域',
    emailGateway: '电子邮件网关',
    injectionProps: '注入参数',
    injectionFields: '注入字段',
    customFields: '自定参数',
    auditTrails: '审计跟踪',
    taxRates: '税率',
    shippingRates: '运费',
    projectProps: '项目参数',
    schedulers: '自动程式',
    tasks: '程式',
    logs: '运行记录',
    requests: '更新请求',
    console: '控制台',
    wallets: '钱包',
    transactions: '转账',
    walletTransactions: '钱包转账',
    walletRequests: '钱包请求',
    userApiKeys: 'User API Keys'
}